'use client';

import { type FragmentType, getFragmentData } from '@gql';
import { useMemo, useState } from 'react';
import { Text } from '../../aurora';
import { CardsSection } from '../cards/card-section';
import type { VildarCardSectionFragment } from '../cards/card-section-gql';
import { TabsSectionFragment } from './tab-section-gql';
import { TabSectionHeader, TabSectionHeaderItem, TabSectionWrapper, TabsSectionWrapper } from './tab-section.styles';

type Props = FragmentType<typeof TabsSectionFragment>;

export function TabSection(props: Props) {
  const { tabs_section: tabSection } = getFragmentData(TabsSectionFragment, props);
  const titles = useMemo(() => tabSection?.tab?.map((t) => t?.title) || [], [tabSection, tabSection?.tab]);

  const [selectedTab, setSelectedTab] = useState<string>(tabSection?.tab?.[0]?.title || '');

  if (!tabSection?.tab || tabSection?.tab?.length < 1) return null;
  return (
    <TabsSectionWrapper>
      <TabSectionHeader>
        {titles.map((title, index) => (
          <TabSectionHeaderItem
            key={`header-item-${index}`}
            $selected={selectedTab === title}
            onClick={() => setSelectedTab(title || '')}
          >
            <Text key={index} $variant="h5" $color={selectedTab === title ? 'primary-base100' : 'ui-textGray'}>
              {title}
            </Text>
          </TabSectionHeaderItem>
        ))}
      </TabSectionHeader>

      {tabSection.tab.map((tab, index) => {
        if (!tab?.card_sectionConnection) return <></>;
        const CardSectionFragmentData = { cards: { card_sectionConnection: tab.card_sectionConnection } };
        return (
          <TabSectionWrapper key={`tab-section-${index}`} $selected={selectedTab === tab.title}>
            <CardsSection
              key={`card-section-${index}`}
              {...(CardSectionFragmentData as FragmentType<typeof VildarCardSectionFragment>)}
            />
          </TabSectionWrapper>
        );
      })}
    </TabsSectionWrapper>
  );
}
